"use client";

import {
  getSessionTokenFrontendDomain,
  getSupertokensAppName,
  getWebsiteDomain,
} from "@/config/app.config";
import EmailPassword from "supertokens-auth-react/recipe/emailpassword";
import { EmailPasswordPreBuiltUI } from "supertokens-auth-react/recipe/emailpassword/prebuiltui";
import Session from "supertokens-auth-react/recipe/session";
import type { SuperTokensConfig as SuperTokensFrontendConfig } from "supertokens-auth-react/lib/build/types";
import {
  buildLoginPath,
  LOGIN_PATH,
  REFRESH_SESSION_PATH,
} from "@workspace/core/auth/redirect";

// Mantenha em paridade com `apps/web/config/auth/supertokens/frontend/frontend.tsx`.
export function getSuperTokensConfig(): SuperTokensFrontendConfig {
  const sessionTokenFrontendDomain = getSessionTokenFrontendDomain();

  return {
    appInfo: {
      appName: getSupertokensAppName(),
      // Mesma origem do frontend + proxy /api, igual ao app web. Falar direto com
      // a API deixaria o navegador guardar o `Set-Cookie` cru do backend, com
      // `Domain` e `Path` proprios, enquanto o web guarda o normalizado — dois
      // cookies de mesmo nome em escopos distintos, que o backend recusa por
      // ambiguidade. Same-origin tambem garante que `front-token` chegue ao SDK
      // sem depender de `access-control-expose-headers`.
      apiDomain: getWebsiteDomain(),
      websiteDomain: getWebsiteDomain(),
      apiBasePath: "/api/auth",
      websiteBasePath: "/auth",
    },

    // `/auth/login` do admin redireciona para o login central no web.
    getRedirectionURL: async (context) => {
      if (context.action === "TO_AUTH") {
        return LOGIN_PATH;
      }

      return undefined;
    },

    recipeList: [
      EmailPassword.init(),
      Session.init({
        // Força uso de cookies ao invés de headers para tokens
        tokenTransferMethod: "cookie",
        // Permite compartilhar cookies entre subdomínios
        ...(sessionTokenFrontendDomain && { sessionTokenFrontendDomain }),
        onHandleEvent: (event) => {
          // O SDK so dispara isto depois que o refresh automatico falhou: a
          // sessao acabou de verdade. Volta ao login lembrando onde o usuario
          // estava, em vez de deixar a tela quebrada ate um F5.
          if (
            event.action !== "UNAUTHORISED" ||
            !event.sessionExpiredOrRevoked ||
            event.userContext?.suppressAuthRedirect === true ||
            window.location.pathname === LOGIN_PATH ||
            window.location.pathname === REFRESH_SESSION_PATH
          ) {
            return;
          }

          const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
          window.location.replace(buildLoginPath(currentPath));
        },
      }),
    ],
  } satisfies SuperTokensFrontendConfig;
}

export const PreBuiltUIList = [EmailPasswordPreBuiltUI];
